import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-modal-header-toolbar',
  template: '<ng-content />',
  host: {
    '[class.td-wb-modal__header-toolbar]': 'true'
  }
})
export class ModalHeaderToolbarComponent {
}
